module.exports = __webpack_public_path__ + "img/logo.a193ac38.png";